import React from "react";

const topUsers = [
  {
    rank: "./assets/silver-medal.png",
    name: "Username",
    score: "Score",
    img: "../assets/top2.png",
  },
  {
    rank: "./assets/gold-medal.png",
    name: "Username",
    score: "Score",
    img: "../assets/top1.png",
  },
  {
    rank: "./assets/bronze-medal.png",
    name: "Username",
    score: "Score",
    img: "../assets/top3.png",
  },
];

export default function Today() {
  return (
    <div className="relative p-6 bg-gradient-to-r from-purpl via-pink-500 to-red-500 rounded-lg mt-3 min-h-screen overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-purple via-pink-500 to-red-500 blur-0 opacity-70 rounded-lg"></div>
      <div
        className="relative p-6  rounded-lg shadow-md min-h-screen bg-no-repeat bg-cover mx-auto mx-w-lg"
        style={{ backgroundImage: "url('../assets/leaderboard-back.png')" }}
      >
        <div>
          <div
            className="flex justify-center items-center gap-32 mb-4 mt-10 h-[168.53px]  bg-no-repeat bg-cover"
            style={{ backgroundImage: "url('../assets/Rectangle-2.png')" }}
          >
            {topUsers.map((user, index) => (
              <User key={index} user={user} />
            ))}
          </div>
          <div>
            <LeaderBoardTable />
          </div>
        </div>
      </div>
    </div>
  );
}

function User({ user }) {
  return (
    <div className="flex bg-white justify-between items-center w-[350px] p-2 rounded-lg shadow-md">
      <div className="flex ml-4 gap-4">
        <img src={user.rank} alt="Rank" className="w-20" />
        <div>
          <p className="font-bold text-[#5002D0] text-[20px] font-Nunito">
            {user.name}
          </p>
          <p className="font-semibold font-Nunito">{user.score}</p>
        </div>
      </div>
      <img src={user.img} alt="User" className="w-12 h-12 rounded-full" />
    </div>
  );
}

function LeaderBoardTable() {
  return (
    <>
      <table className="w-full rounded-lg  mt-12 mx-auto p-3">
        <thead className="text-white">
          <tr>
            <th className="py-2">S/no</th>
            <th className="py-2">Photo</th>
            <th className="py-2">Username</th>
            <th className="py-2">Rank</th>
            <th className="py-2">Overall Score</th>
            <th className="py-2">Email address</th>
          </tr>
        </thead>
        <tbody className="text-white font-semibold">
          {[...Array(15)].map((_, i) => (
            <LeaderBoardTableRow key={i} i={i} />
          ))}
        </tbody>
      </table>
    </>
  );
}

function LeaderBoardTableRow({ i }) {
  return (
    <>
      <tr className="">
        <td className="py-2">{i + 1}</td>
        <td className="py-2">
          <img src="../assets/top1.png" alt="User" className="rounded-full" />
        </td>
        <td className="py-2">Username</td>
        <td className="py-2">001</td>
        <td className="py-2">1230</td>
        <td className="py-2">user@gmail.com</td>
      </tr>
    </>
  );
}
